export const STORE_POLICY_PAGE_TYPE = {
  TERMS_AND_CONDITIONS: 1,
  RETURN_AND_REFUND: 2,
  PRIVACY_POLICY: 3,
  SHIPPING_AND_PAYMENT: 4,
  INVOICE_DISCLAIMER: 5,
};
